// FeatureFlags were `undefined` in unit tests without `const`
export const enum FeatureFlag {
  PLG = 'UI.PLG.Enabled',
  ROLLOUT_PLG_DMARC2_SKU = 'rollout-plg-dmarc2-sku',
  PLG_COLLABORATION_SECURITY = 'UI.PLG.COLLABORATION_SECURITY.Enabled',
  ROLLOUT_PAL_PLG_COLLAB_SECURITY = 'rollout-pal-plg-collab-security',
  ROLLOUT_PAL_PLG_PHASE_1 = 'rollout-pal-plg-phase-1',
  ROLLOUT_PAL_PLG_PHASE_2 = 'rollout-pal-plg-phase-2',
  ROLLOUT_PLG_ENGAGE_ADVANCED_SKU = 'rollout-plg-engage-advanced-sku',
  COMMON_NAV_FRAMEWORK = 'rollout-common-nav-framework',
  EMBED_AWARENESS_TRAINING = 'UI.Embed.Awareness-Training',
  AWARENESS_TRAINING_SCORECARDS = 'rollout-awareness-training-scorecards',
  AWARENESS_TRAINING_CAMPAIGNS = 'rollout-awareness-training-campaigns',
  AWARENESS_TRAINING_TARGETED_TRAINING_READONLY = 'rollout-awareness-training-targeted-training-readonly',
  AWARENESS_TRAINING_VIMEO_ENABLED = 'rollout-awareness-training-vimeo-enable',
  ENGAGE_SEASON_9_RELEASE_ENABLED = 'Engage.Season.9.Release-Date_Based',
  BILLING_SUBSCRIPTION_OVERVIEW = 'rollout-billing-subscription-overview',
  CYBER_GRAPH_2 = 'UI.CyberGraph.Enabled',
  CYBER_GRAPH_2V1 = 'UI.CyberGraph.2.1.Enabled',
  DMARC_1_AND_2_CUSTOMERS = 'dmarc-both-version-customers',
  DMARC_2 = 'rollout-dmarc-2-0',
  DMARC_2_MIGRATION = 'rollout-dmarc2-migration',
  DMARC_2_MIGRATION_ADMIN = 'rollout-dmarc2-migration-admin',
  DMARC_2_DOMAIN_DISCOVERY = 'rollout-dmarc2-domain-discovery',
  DMARC_2_VM = 'rollout-dmarc2-vendor-mngmt',
  DMARC_2_VM_CONFIGURATION = 'rollout-dmarc2-vendor-config',
  DMARC_2_DNS_DELEGATION = 'rollout-dmarc2-dns-delegation',
  DMARC_2_DNS_DELEGATION_DMARC = 'rollout-dmarc2-dmarc-delegation',
  DMARC_2_DNS_DELEGATION_DKIM = 'rollout-dmarc2-dkim-delegation',
  DMARC_2_DNS_CHECKER = 'rollout-dmarc2-dns-checker',
  DMARC_2_DNS_GENERATOR = 'rollout-dmarc2-dns-generator',
  DMARC_2_TIMELINE = 'rollout-dmarc2-timeline',
  DMARC_2_TASK_MANAGER = 'rollout-dmarc2-task-manager',
  DMARC_2_USER_PERMISSIONS = 'rollout-dmarc2-user-mngmt',
  DMARC_2_NOTIFICATIONS = 'rollout-dmarc2-notifications',
  DMARC_2_NOTIFICATIONS_COMPLIANCE_MONITOR = 'rollout-dmarc2-notifications-compliance-monitor',
  DMARC_2_NOTIFICATIONS_DMARC_SUMMARY = 'rollout-dmarc2-notifications-dmarc-summary',
  DMARC_2_NOTIFICATIONS_DNS_MONITOR = 'rollout-dmarc2-notifications-dns-monitor',
  DMARC_2_COMPLIANCE_REPORT = 'rollout-dmarc2-compliance-report',
  DMARC_2_COMPLIANCE_STATUS = 'rollout-dmarc2-compliance-status',
  DMARC_2_CHANGE_OVER_TIME = 'rollout-dmarc2-change-over-time',
  DMARC_2_COMPLIANCE_ACTIONS = 'rollout-dmarc2-compliance-actions',
  URL_PROTECTION_LOGS = 'rollout-url-protection-logs-breadcrumbs',
  ARC_POST_GA = 'rollout-arc-post-ga',
  ROLLOUT_CYG_21_IMAGE_TRACKER_UI = 'rollout-cyg-21-image-tracker-ui',
  ROLLOUT_CYG_TRACKER_UI_SUNSET_ENABLED = 'rollout-cyg-tracker-ui-sunset-enabled',
  ROLLOUT_CYG_BANNER_REPORT_LOCALIZATION = 'rollout-cyg-banner-report-localization-ui',
  ROLLOUT_CYG_TRIGGERED_DOMAIN_SEARCH_UI = 'rollout-cyg-triggered-domain-search-ui',
  CYBER_GRAPH_SEVERITY_TITLE = 'rollout-cyg-severity-title-ui',
  MICROSOFT_NATIVE_REPORTING_ENABLED = 'rollout_msft_native_reporting_for_existing_customer_CG',
  UNIFIED_AR_HOME = 'rollout-arc-foundation-homepage',
  REMOVE_APP_SWITCHER = 'rollout-remove-app-switcher',
  ROLLOUT_AWS_ADCON4_IFRAME = 'rollout-aws-adcon4-iframe',
  ARC_BEC_CONTENT_ANALYSIS = 'arc.bec.content.analysis',
  SHOW_RENAME_TO_SUSPICIOUS = 'show_rename_to_suspicious',
  HTML_TEXT_CONTENT_BEC = 'rollout-html-text-content-bec',
  /** misnomer because Provisioning Integrations was the first page under Multi Account Controls */
  PROVISIONING_INTEGRATIONS = 'UI.MultiAccountControls.Enabled',
  TENANT_API_GATEWAY = 'tenant-api-gateway',
  TENANT_API_GATEWAY_POST_GA = 'tenant-api-gateway.post-ga',
  ROLLOUT_UNIFIED_AR_THREAT_DETAILS_PAGE = `rollout-unified-ar-threat-details-page`,
  INTEGRATIONS_MARKETPLACE = 'UI.Integrations.Marketplace.Enabled',
  INTEGRATIONS_MARKETPLACE_CI = 'rollout-integrations-marketplace-cg',
  LOCALIZATION = 'rollout-localization-settings',
  /**
   * We're relying on a lot of APIs to gate access to portions of the app
   * if this flag is true, we'll proceed to the next part of the app where we'd
   * otherwise deny access.
   * */
  INTEGRATIONS_API_CHECKS_FAIL_OPEN = 'UI.Test.Integrations.ApiChecksFailOpen.Enabled',
  TEST_INTEGRATIONS_CATALOG = 'UI.Test.Integrations.Catalog.Enabled',
  INTEGRATIONS_SENTINEL_ONE_V1 = 'UI.Integrations.Tile.SentinelOne.v1.Enabled',
  INTEGRATIONS_NETSKOPE_V1 = 'UI.Integrations.Tile.Netskope.v1.Enabled',
  INTEGRATIONS_INCYDR_V1 = 'UI.Integrations.Tile.Incydr.v1.Enabled',
  INTEGRATIONS_OKTA_V1 = 'UI.Integrations.Tile.Okta.v1.Enabled',
  INTEGRATIONS_SOPHOS_V1 = 'UI.Integrations.Tile.Sophos.v1.Enabled',
  INTEGRATIONS_MICROSOFT_ATTACK_SIMULATION_V1 = 'UI.Integrations.Tile.MicrosoftAttackSimulation.v1.Enabled',
  INTEGRATIONS_PALO_ALTO_NETWORKS_MALWARE_V1 = 'UI.Integrations.Tile.PaloAltoNetworksMalware.v1.Enabled',
  INTEGRATIONS_TREND_MICRO_XDR_V1 = 'UI.Integrations.Tile.TrendMicroXdr.v1.Enabled',
  INTEGRATIONS_DUO_V1 = 'UI.Integrations.Tile.Duo.v1.Enabled',
  INTEGRATIONS_CISCO_XDR_V1 = 'UI.Integrations.Tile.CiscoXDR.v1.Enabled',
  INTEGRATIONS_CYBERARK_IDENTITY_V1 = 'UI.Integrations.Tile.CyberArkIdentity.v1.Enabled',
  INTEGRATIONS_GOOGLE_WORKSPACE_IDENTITY_V1 = 'UI.Integrations.Tile.GoogleWorkspaceIdentity.v1.Enabled',
  INTEGRATIONS_GOOGLE_WORKSPACE_PHISHING_V1 = 'UI.Integrations.Tile.GoogleWorkspacePhishing.v1.Enabled',
  INTEGRATIONS_GOOGLE_WORKSPACE_SDH_V1 = 'UI.Integrations.Tile.GoogleWorkspaceSDH.v1.Enabled',
  INTEGRATIONS_CROWDSTRIKE_ALERTS_V1 = 'UI.Integrations.Tile.crowdstrike.alerts.v1.Enabled',
  INTEGRATIONS_CROWDSTRIKE_THREAT_SHARE_V1 = 'UI.Integrations.Tile.CrowdstrikeThreatShare.v1.Enabled',
  INTEGRATIONS_CROWDSTRIKE_CASES_MODE = 'rollout-crowdstrike-cases-mode',
  INTEGRATIONS_API2_ENABLED_WAVE1_V1 = 'UI.Integrations.Tile.Group.Api2.Enabled',
  INTEGRATIONS_API2_ENABLED_WAVE2_V1 = 'rollout-integrations-api2.0-wave2',
  INTEGRATIONS_API2_ENABLED_WAVE3_V1 = 'rollout-integrations-api2.0-wave3',
  INTEGRATIONS_BRAND_EXPLOIT_PROTECTION_V1 = 'rollout-integrations-brand-exploit-protection',
  INTEGRATIONS_ALWAYS_DISABLED = 'UI.Integrations.Tile.Group.Api2.Disabled',
  INTEGRATIONS_ZSCALER_GOVT_URL_SUPPORT = 'rollout-zscaler-gov-url-support',
  INTEGRATIONS_ZSCALER_V1 = 'rollout-integrations-zscaler-v1',
  INTEGRATIONS_STATUS_DETAILS_TABLE_COLUMN = 'rollout-status-details-table-column',
  INTEGRATIONS_MICROSOFT_DEFENDER_FOR_ENDPOINT_V1 = 'UI.Integrations.Tile.MicrosoftDefenderForEndpoint.v1.Enabled',
  INTEGRATIONS_MICROSOFT_DEFENDER_FOR_OFFICE_365_V1 = 'UI.Integrations.Tile.MicrosoftDefenderForOffice365.v1.Enabled',
  INTEGRATIONS_DIRECT_MESSAGE_INJECTION_V1 = 'UI.Integrations.Tile.DirectMessageInjection.v1.Enabled',
  INTEGRATIONS_DIRECT_MESSAGE_INJECTION_INTEGRATION_LIMIT_INCREASE = 'UI.Integrations.Tile.DirectMessageInjection.Increase.Limit',
  INTEGRATIONS_DIRECT_MESSAGE_INJECTION_GOOGLE_WORKSPACE_V1 = 'UI.Integrations.Tile.DirectMessageInjectionGoogleWorkspace.v1.Enabled',
  INTEGRATIONS_MICROSOFT_PURVIEW_V1 = 'UI.Integrations.Tile.MicrosoftPurview.v1.Enabled',
  INTEGRATIONS_MICROSOFT_ENTRA_ID_PROTECTION_V1 = 'UI.Integrations.Tile.MicrosoftEntraIdProtection.v1.Enabled',
  INTEGRATIONS_MICROSOFT_OUTBOUND_ADAPTIVE_CONTROL_V1 = 'rollout-integrations-microsoft-outbound-adaptive-control-v1',
  INTEGRATIONS_ENTRA_ID_SIGNAL_COLLECTOR_V1 = 'UI.Integrations.Tile.EntraIDSignalCollector.v1.Enabled',
  INTEGRATIONS_MICROSOFT_OIDC_AUTHENTICATION_V1 = 'rollout-integrations-oidc-microsoft',
  INTEGRATIONS_EVENT_PUSH_V1 = 'rollout-integrations-event-push-v1',
  INTEGRATIONS_GOOGLE_THREAT_INTELLIGENCE_V1 = 'rollout-integrations-google-threat-intelligence-v1',
  INTEGRATIONS_MIMECAST_GENERIC_TILE_API2_V1 = 'rollout-integrations-mimecast-generic-tile-api2-v1',
  INTEGRATIONS_SAP_SUCCESS_FACTORS_INCYDR_V1 = 'rollout-integrations-sap-success-factors-incydr-v1',
  TRR_REPORTING_FOR_SUPPORT = 'rollout-trr-reporting-for-support-enabled',
  ROLLOUT_TRR_FORWARD_AS_ATTACHMENT_REPORTING = 'rollout-trr-forward-as-attachment-reporting',
  TRR_CONNECTOR_MULTITENANT_ENABLED = 'trr.connector.multitenant.enabled',
  ROLLOUT_AR_NON_MEIR = 'rollout-ar-non-meir',
  ROLLOUT_AR_REPORTED_EMAIL_DASHBOARD = 'rollout-ar-reported-email-dashboard',
  ROLLOUT_AR_REPORTED_EMAILS_AI_ASSISTANT = 'rollout-ar-reported-emails-ai-assistant',
  ROLLOUT_AR_REPORTED_EMAILS_GWS = 'rollout-ar-reported-emails-gws',
  ROLLOUT_AR_SCHEDULED_REPORTS = 'rollout-ar-scheduled-reports',
  ROLLOUT_REPORTED_EMAILS_EXPORT = 'rollout-reported-emails-export',
  ROLLOUT_MEIR_SOURCE_FILTER = 'rollout-meir-source-filter',
  INTEGRATIONS_CROWDSTRIKE_VERIFY_CONNECTION = 'UI.Integrations.Crowdstrike.Verify.Connection.Enabled',
  INTEGRATIONS_CROWDSTRIKE_SEND_TO_NEW_UI = 'rollout-crowdstrike-threat-share-send-to-section-new-ui',
  INTEGRATIONS_THREAT_SHARE_SEND_FROM_MIMECAST_EXCLUDE_KNOWN_DOMAINS_ENABLED = 'rollout-threat-share-send-from-mimecast-exclude-known-domains-enabled',
  INTEGRATIONS_CROWDSTRIKE_THREAT_SHARE_SEND_TO_MIMECAST_EXCLUDE_KNOWN_DOMAINS_ENABLED = 'rollout-crowdstrike-threat-share-send-to-mimecast-exclude-known-domains-enabled',
  INTEGRATIONS_NOTIFICATION_GROUPS = 'rollout-integrations-notification-groups',
  INTEGRATIONS_INTEGRATION_MANAGEMENT_PRODUCT_ENABLED = 'rollout-integration-management-product-enabled',
  INTEGRATIONS_DIRECTORY_MANAGEMENT_PRODUCT_ENABLED = 'rollout-directory-management-product-enabled',
  INTEGRATIONS_THREAT_SHARE_ENABLE_DISABLE = 'rollout-integrations-threat-share-enable-disable',
  INTEGRATIONS_DISABLED_STATUS_ENABLED = 'rollout-integrations-disabled-status-enabled',
  INTEGRATIONS_SLACK_NOTIFICATION_V1 = 'UI.Integrations.Tile.SlackNotification.v1.Enabled',
  INTEGRATIONS_TEAMS_NOTIFICATION_V1 = 'UI.Integrations.Tile.TeamsNotification.v1.Enabled',
  INTEGRATIONS_SHOW_PRODUCT_CHIPS_V1 = 'rollout-integrations-product-chip-enabled',
  INTEGRATIONS_API2_PRODUCTS_AND_ROLE_ENABLED = 'rollout-integrations-api2-products-and-role-enabled',
  ROLLOUT_HOMEPAGE_REPORTING_ENHANCEMENTS = 'rollout-homepage-reporting-enhancements',
  ROLLOUT_HOMEPAGE_REPORTING_ENHANCEMENTS_P1 = 'rollout-homepage-reporting-enhancements-P1',
  ROLLOUT_HOMEPAGE_REPORTING_ENHANCEMENTS_P2 = 'rollout-homepage-reporting-enhancements-P2',
  INTEGRATIONS_EVENT_PUSH_NEW_UI = 'rollout-event-push-authentication-configuration-section-new-ui',
  INTEGRATIONS_EVENT_PUSH_HUMAN_RISK_UI = 'rollout-event-push-human-risk-ui',
  INTEGRATIONS_EVENT_PUSH_HUMAN_RISK_0_100_SCALE = 'rollout-event-push-human-risk-0-100-scale',
  INTEGRATIONS_EVENT_PUSH_INCYDR_UI = 'rollout-event-push-incydr-ui',
  ROLLOUT_BEC_MONITOR_OPTION = 'rollout-bec-monitor-option',
  BEC_DETECTIONS_POLICY_MODELLING = 'rollout-bec-detection-policy-modelling',
  ROLLOUT_UNIFIED_AR_THREAT_DETAILS_SPOD_FAPI = `rollout-unified-ar-threat-details-spod-fapi`,
  ROLLOUT_BEC_FROM_TO_LIST = 'rollout-bec-from-to-list',
  ROLLOUT_BEC = 'rollout-business-email-compromise',
  ROLLOUT_REPORTING_TO_FEP = 'rollout-reporting-fep-migration',
  ROLLOUT_DIRECTORY_SYNC_MIGRATION = 'rollout-directory-sync-migration',
  ROLLOUT_ADCON_DIRECTORY_SYNC = 'rollout-adcon-directory-sync',
  ROLLOUT_CYBERGRAPH_POLICIES_HRM = 'rollout-cybergraph-policies-hrm',
  MSP_ONBOARDING = 'rollout-msp-onboarding',
  ROLLOUT_MSP_DELEGATED_ADMIN_MANAGEMENT = 'rollout-msp-delegated-admin-management',
  MICROSOFT_NAA = 'rollout-naa-for-meo',
  ONBOARDING_PHASE_2 = 'rollout-onboarding-phase-2',
  ROLLOUT_ALLOW_BLOCK_SENDER_DETECTION = 'rollout-allow-block-sender-detection',
  ROLLOUT_OPEN_IN_BROWSER_ISOLATION = 'rollout-open-in-browser-isolation',
  ROLLOUT_CI_POLICY_NAME_SEARCH = 'rollout_ci_policy_name_search',
  SHOW_IGNORE_QUARANTINE = 'show_ignore_quarantine',
  ROLLOUT_CHP_GROUP_OPTION = 'rollout-custom-header-group-selection',
  ROLLOUT_AUDIT_LOGS_PP = 'rollout-pp-audit-logs-fep',
  SHOW_RESTORE_FOR_REMEDIATED_OFFICE_365_DETECTION = 'show-restore-for-remediated-office-365-detection',
  ROLLOUT_DMARC_CG = `rollout-dmarc-cg`,
  ROLLOUT_HIDE_MIMECASTER_CENTRAL_SEARCH = 'rollout-hide-mimecaster-central-search',
  ROLLOUT_KNOWLEDGE_HUB = 'rollout-knowledge-hub',
  CUSTOM_HEADER_POLICY = 'rollout-custom-header-policy',
  ROLLOUT_SHOW_HUMAN_RISK_FOR_ALL = 'rollout-show-human-risk-for-all',
  ROLLOUT_APPLICATION_SETTINGS = 'rollout-application-settings',
  ROLLOUT_EIR_CLASSIFICATION_SETTINGS = 'rollout-eir-classification-settings',
  ROLLOUT_ROLES_AND_PERMISSIONS = 'rollout-roles-and-permissions-pages',
  ROLLOUT_USER_MANAGEMENT = 'rollout-user-management',
  ROLLOUT_PACKAGES_INFO = 'rollout-packages-info',
  SHOW_SUPPORT_USER_ACTIVE = 'show-support-user-active',
  ROLLOUT_CISO_REPORT = 'rollout-ciso-report',
  ROLLOUT_HRIR_V2 = 'rollout-hrir-v2',
  ROLLOUT_SHOW_HUMAN_RISK_FOR_SAFESCORE_EOL = 'rollout-show-human-risk-for-safescore-eol',
  ROLLOUT_AUDIT_LOG_IMPROVEMENTS = 'rollout-audit-log-improvements',
  ROLLOUT_AUDIT_CATEGORY_CAPABILITY = 'rollout-audit-category-capability',
  ROLLOUT_AUTHENTICATION_PROFILES = 'rollout-auth-profiles-page',
  ROLLOUT_GROUPS = 'rollout-groups',
  ROLLOUT_GW_DIRECTORIES_ATTRIBUTES = 'rollout-gw-directories-attributes',
  ROLLOUT_DATA_LEAK_PREVENTION = 'rollout-data-leak-prevention',
  ROLLOUT_GW_SECURE_MESSAGING = 'rollout-gw-secure-messaging',
  ROLLOUT_GW_SECURE_MESSAGING_MONITORING = 'rollout-gw-secure-messaging-monitoring',
  ROLLOUT_GW_SERVICES_THREAT_REMEDIATION = 'rollout-gw-services-threat-remediation',
  ROLLOUT_GW_SERVICES_THREAT_REMEDIATION_REMOVE_ALL = 'rollout-gw-services-threat-remediation-remove-all',
  ROLLOUT_SEND_SHIELD_DISTRIBUTION = 'rollout-send-shield-distribution',
  ROLLOUT_GW_MESSAGE_CENTER_BOUNCED_MESSAGE = 'rollout-gw-message-center-bounced-message',
  ROLLOUT_GW_MESSAGE_CENTER_MESSAGE_DELIVERY = 'rollout-gw-message-center-message-delivery',
  ROLLOUT_GW_MESSAGE_CENTER_REJECTED_AND_DEFERRED = 'rollout-gw-message-center-rejected-and-deferred',
  ROLLOUT_GW_MESSAGE_CENTER_PROCESSING_QUEUES = 'rollout-gw-message-center-processing-queues',
  ROLLOUT_GW_MESSAGE_CENTER_HELD_MESSAGES = 'rollout-gw-message-center-held-messages',
  ROLLOUT_GW_MESSAGE_CENTER_ACCEPTED_MESSAGES = 'rollout-gw-message-center-accepted-messages',
  ROLLOUT_GW_MESSAGE_CENTER_MESSAGE_TRACKING = 'rollout-gw-message-center-message-tracking',
  ROLLOUT_GW_POLICIES_BI = 'rollout-gw-policies-bi',
  ROLLOUT_GW_POLICIES_MEP = 'rollout-gw-policies-mep',
  ROLLOUT_GW_POLICIES_CUSTOM_DOMAIN_BLOCK = 'rollout-gw-policies-custom-domain-block',
  ROLLOUT_GW_WEB_SECURITY_DASHBOARD = 'rollout-gw-web-security-dashboard',
  ROLLOUT_GW_WEB_SECURITY_LOCATIONS = 'rollout-gw-web-security-locations',
  ROLLOUT_GW_WEB_SECURITY_EXCEPTIONS = 'rollout-gw-web-security-exceptions',
  ROLLOUT_GW_WEB_SECURITY_URL_LOOKUP = 'rollout-gw-web-security-url-lookup',
  ROLLOUT_GW_WEB_SECURITY_ACTIVITY_REPORT = 'rollout-gw-web-security-activity-report',
  ROLLOUT_GW_WEB_SECURITY_SECURITY_REPORT = 'rollout-gw-web-security-security-report',
  ROLLOUT_ATTACHMENT_PROTECTION_NATIVE = 'rollout-attachment-protection-native',
  ROLLOUT_URL_PROTECTION_NATIVE = 'rollout-url-protection-native',
  ROLLOUT_GW_WEB_SECURITY_AGENT_SETTINGS = 'rollout-gw-web-security-agent-settings',
  ROLLOUT_GW_WEB_SECURITY_CERTIFICATE_DNS = 'rollout-gw-web-security-certificate-dns',
  ROLLOUT_GW_WEB_SECURITY_POLICIES = 'rollout-gw-web-security-policies',
  ROLLOUT_GW_WEB_SECURITY_CLOUD_APPLICATIONS = 'rollout-gw-web-security-cloud-applications',
  ROLLOUT_GW_WEB_SECURITY_PROTECTED_DEVICES = 'rollout-gw-web-security-protected-devices',
  ROLLOUT_GW_EMAIL_SECURITY_IMPERSONATION_LOGS = 'rollout-gw-email-security-impersonation-logs',
  ROLLOUT_SECURE_MESSAGING_2FA = 'secure.messaging.2fa',
  ROLLOUT_CI_ROLE_BASED_ACCESS = 'rollout-role-based-access',
  SHOW_BEC_SETTINGS_POLICY = 'rollout-bec-settings-policy',

  // GWL
  ROLLOUT_GWL = 'rollout-gwl',
  ROLLOUT_GWL_ANALYSIS_RESPONSE = 'rollout-gwl-analysis-response',
  ROLLOUT_GWL_REPORTS = 'rollout-gwl-reports',
  ROLLOUT_GWL_REPORTS_WEEKLY = 'rollout-gwl-reports-weekly',
  ROLLOUT_GWL_POV = 'rollout-gwl-pov',
  ROLLOUT_POV_HISTORICAL_SCAN = 'rollout-pov-historical-scan',
  ROLLOUT_GWL_PHISHING_PILOT = 'rollout-gwl-phishing-pilot',
  ROLLOUT_GWL_GWS = 'rollout-gwl-gws',
  ROLLOUT_GWL_EXTRA_INTEGRATIONS = 'rollout-gwl-extra-integrations',
  ROLLOUT_GWL_EVENT_PUSH = 'rollout-gwl-event-push',
  ROLLOUT_GWL_REAL_TIME_SCAN = 'rollout-gwl-real-time-scan',
  ROLLOUT_GWL_ANR_SPAM = 'rollout-gwl-anr-spam',
  ROLLOUT_GWL_LOCAL_GROUPS = 'rollout-gwl-local-groups-label',
  ROLLOUT_GWL_ANR_IMPERSONATION = 'rollout-gwl-anr-impersonation',
  ROLLOUT_OUTBOUND_PHASE_1 = 'rollout-outbound-phase1',

  ROLLOUT_URL_CLICKS_AR = 'rollout-url-clicks-ar',
  ROLLOUT_AR_QUARANTINE_HISTORY = 'rollout-ar-quarantine-history',

  ROLLOUT_USER_ACTIVITY_LOGS = 'rollout-user-only-activity-logs-ui',
  INTEGRATIONS_MICROSOFT_DEFENDER_THREAT_SHARE_V1 = 'rollout-integrations-microsoft-defender-threatshare-v1',
  DISPLAY_MESSAGE_BODY = 'display-message-body',
  ROLLOUT_BOWSER_GATEKEEPER_AI_POLICY = 'rollout_bowser_gatekeeper_ai_policy',
  ROLLOUT_PHISHING_POLICY = 'rollout-phishing-policy',
  ROLLOUT_SPAM_POLICY = 'rollout-gwl-spam-policy',
  ROLLOUT_GRAYMAIL_ACTION_MONITOR = 'rollout-graymail-action-monitor',
  ROLLOUT_GRAYMAIL_CATEGORY = 'rollout-graymail-category',
  ROLLOUT_CYG_UI_FEEDBACK = 'rollout-cyg-ui-feedback',
  ROLLOUT_RENAME_CYBERGRAPH_TO_BANNERING = 'rollout-rename-cybergraph-to-bannering',
  ROLLOUT_ZENDESK_WIDGET = 'rollout-zendesk-widget',
  BEC_EXPLAINABILITY = 'rollout-bec-explainability',
  ROLLOUT_INCYDR_SSO = 'rollout-incydr-sso',
  ROLLOUT_CONNECT_EOL = 'rollout-connect-eol',
  ATO = 'rollout-ato-update',
  ROLLOUT_1MC_DASHBOARD = 'rollout-1mc-dashboard',
  ROLLOUT_INCYDR_HOMEPAGE_DASHBOARD = 'rollout-incydr-homepage-dashboard',
  ROLLOUT_IMPROVE_VISIBILITY = 'rollout-improve-visibility',
  ROLLOUT_INCYDR_ATO = 'rollout-incydr-ato',
  ROLLOUT_ATO_SIGNALS = 'rollout-ato-signals',
  ROLLOUT_ATO_RESTRICTED_USERS = 'rollout-ato-restricted-users',
  ROLLOUT_ALLOW_RULES = 'rollout-allow-rules',
  ROLLOUT_URL_POLICY = 'rollout-url-protection-policy',
  ROLLOUT_SECURE_DELIVERY_CONFIGURATION = 'rollout-secure-delivery-configuration',
  ROLLOUT_EMAIL_DATA_LOSS_PROTECTION = 'rollout-email-data-loss-protection',
  ROLLOUT_MALWARE_POLICY = 'rollout-malware-protection-policy',
  ROLLOUT_PERMIT_RULES_URL = 'rollout-permit-rules-url',
  ROLLOUT_BOWSER_DETECTION = 'rollout-bowser-detection',
  ROLLOUT_ENGAGE_MENU = 'rollout-engage-menu',
  ROLLOUT_ENGAGE_MANAGER_NOTIFICATION = 'rollout-engage-manager-notification',
  ROLLOUT_CAMPAIGNS_UI_UPDATES = 'rollout-campaigns-ui-updates',
  ROLLOUT_CAMPAIGNS_LIST_UPDATE = 'rollout-campaigns-list-update',
  ROLLOUT_CAMPAIGNS_TABLE_EXPORT = 'rollout-campaigns-table-export',
  ROLLOUT_AWARENESS_TRAINING_REPORTING = 'rollout-awareness-training-reporting',
  ROLLOUT_ENGAGE_REPORTING_PHASE2 = 'rollout-engage-reporting-phase2',
  /** New Reporting & Insights Employee Detail (header / risk / KPIs). */
  ROLLOUT_ENGAGE_REPORTING_EMPLOYEE_DETAIL_PHASE2 = 'rollout-engage-reporting-employee-detail-phase2',
  ROLLOUT_CR_FOR_SEG_ONLY = 'rollout_cr_for_seg_only',
  ROLLOUT_CYG_HOURLY_TABLES_UI = 'rollout-cyg-hourly-tables-ui',
  ROLLOUT_ACCOUNT_ANALYSIS = 'rollout-account-analysis',
  ROLLOUT_ATO_NO_EA = 'rollout-ato-no-early-access',
  ROLLOUT_VENDOR_EMAIL_COMPROMISE = 'rollout-vendor-email-compromise',

  // CBR M365 Exchange
  INTEGRATIONS_CBR_M365_EXCHANGE_V1 = 'UI.Integrations.Tile.CbrM365Exchange.v1.Enabled',

  // CBR OneDrive rollout
  ROLLOUT_CBR_ONEDRIVE = 'rollout_cbr_onedrive',

  // CBR Overview Usage tile (storage & seat consumption)
  ROLLOUT_CBR_USAGE_TILE = 'rollout_cbr_usage_tile',

  ROLLOUT_BACKUP_RECOVERY_MFE = 'rollout-backup-recovery-mfe',

  // ABEC Held Info Column
  ROLLOUT_ABEC_HELD_INFO = 'rollout-abec-held-info',

  ROLLOUT_ABEC_ACTION_HOLD_USER = 'rollout-abec-action-hold-user',

  ROLLOUT_ACCOUNT_SETTINGS = 'rollout-account-settings',
  ROLLOUT_MCP_GCI_INTEGRATION = 'rollout-mcp-gci-integration',
  ROLLOUT_HRCC_MCP = 'rollout-hrcc-mcp',
  ROLLOUT_HRCC_MCP_V2 = 'rollout-hrcc-mcp-v2',
  ROLLOUT_BRANDING_CLIENT_DUMMY_PAGE = 'rollout-branding-client-dummy-page',

  //HRM flags
  HRM = 'rollout-hrm',
  ROLLOUT_APEX_PERSONAL_INTELLIGENCE = 'rollout-apex-personal-intelligence',
  ROLLOUT_APEX_SKIP_PERSONAL_INTELLIGENCE = 'rollout-apex-skip-personal-intelligence',
  ROLLOUT_APEX_WIDGET_DASHBOARD = 'rollout-apex-widget-dashboard',
  ROLLOUT_APEX_ACCOUNT_SETTINGS = 'rollout-apex-account-settings',
  ROLLOUT_APEX_THREAT_RESEARCH_FEED = 'rollout-apex-threat-research-feed',
  ROLLOUT_APEX_DARK_MODE = 'rollout-apex-dark-mode',
  ROLLOUT_APEX_LANDING_PAGE = 'rollout-apex-landing-page',
  INTEGRATIONS_HUMAN_RISK_PRODUCT_ENABLED = 'rollout-human-risk-product-enabled',
  INTEGRATIONS_DMARC_ANALYZER_PRODUCT_ENABLED = 'rollout-dmarc2-analyzer-product-enabled',

  // Converged A&R
  ROLLOUT_ONE_ANALYSIS_RESPONSE = 'rollout-one-analysis-response',
  ROLLOUT_ONE_ANALYSIS_RESPONSE_ENHANCEMENT = 'rollout-one-analysis-response-enhancement',
  ROLLOUT_NEW_THREAT_CATEGORIES = 'rollout-new-threat-categories',
  ROLLOUT_ANR_ENVELOPE_FROM = 'rollout-anr-envelope-from',

  //Cybergraph Dynamic banner export
  ROLLOUT_CYG_EXPORT_ENHANCEMENTS_UI = 'rollout-cyg-export-enhancements-ui',

  // HRCC
  WATCHLIST_CURSOR_BASED_PAGINATION = 'watchlist-cursor-based-pagination',
  ROLLOUT_HRCC_WATCHLIST_INTEGRATION = 'rollout-hrcc-watchlist-integration',
  ROLLOUT_MARK_FP = 'rollout-mark-fp',
  ROLLOUT_HRCC_DASHBOARD_V2 = 'rollout-hrcc-dashboard-v2',

  // App Launcher Migration
  ROLLOUT_APP_LAUNCHER_MIGRATION = 'rollout-app-launcher-migration',

  ROLLOUT_MCP_ENGAGE_INTEGRATION = 'rollout-mcp-engage-integration',
  ROLLOUT_MCP_ENGAGE_CHATGPT_COMING_SOON = 'rollout-mcp-engage-chatgpt-coming-soon',

  ROLLOUT_CROWDSTRIKE_US3_BASE_URL = 'rollout-crowdstrike-us-3-base-url',

  // Custom Flag to Hide GCI Menus
  CUSTOM_HIDE_ARCHIVE_MENUS_IN_SG = 'custom-hide-archive-menus-in-sg',
}

export const defaultFlags: { [key: string]: unknown } = {
  [FeatureFlag.COMMON_NAV_FRAMEWORK]: true,
  [FeatureFlag.HRM]: true,
  [FeatureFlag.ROLLOUT_APEX_PERSONAL_INTELLIGENCE]: false,
  [FeatureFlag.ROLLOUT_APEX_SKIP_PERSONAL_INTELLIGENCE]: true,
  [FeatureFlag.ROLLOUT_AR_REPORTED_EMAILS_AI_ASSISTANT]: false,
  [FeatureFlag.ROLLOUT_ATTACHMENT_PROTECTION_NATIVE]: false,
  [FeatureFlag.ROLLOUT_URL_PROTECTION_NATIVE]: false,
  [FeatureFlag.ROLLOUT_ANR_ENVELOPE_FROM]: false,
  [FeatureFlag.ROLLOUT_SEND_SHIELD_DISTRIBUTION]: false,
};

export const phishingPilotFeatureFlags = new Set([
  'rollout-1mc-dashboard',
  'rollout-gwl',
  'rollout-phishing-policy',
  'rollout-malware-protection-policy',
  'rollout-gwl-spam-policy',
  'rollout-gwl-analysis-response',
  'rollout-allow-rules',
  'rollout-url-protection-policy',
  'rollout-secure-delivery-configuration',
]);
